
import { PuttSituation } from "@/types/golf";
import PuttingSituationCard from "./PuttingSituationCard";

interface PuttingCardGridProps {
  situations: PuttSituation[];
  onSelectSituation: (id: number) => void;
  refreshAfterToast?: () => void;
}

const PuttingCardGrid = ({ situations, onSelectSituation, refreshAfterToast }: PuttingCardGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {situations.map((situation, index) => (
        <PuttingSituationCard
          key={situation.id}
          situation={situation}
          index={index}
          onSelect={onSelectSituation}
          refreshAfterToast={refreshAfterToast}
        />
      ))}
    </div>
  );
};

export default PuttingCardGrid;
